import {
  setChatbotHasPollAnswers,
  setChatbotRowVersion,
  setChatbotUnreadMessagesCount,
  setChatbotPeriodicity,
  setChatbotPollingIntervalId,
} from '../../actions/chatbot/actions';
import { setMessagesFulfilled } from '../../actions/messages';
import { CHATBOT_ID } from '../../constants/chatbotId';
import { fetchChatbotMessages } from '../../services/fetchChatbotMessages';
import { fetchChatbotReadMessages } from '../../services/fetchChatbotReadMessages';
import { TThunkAction } from '../../types/redux/thunk';
import { findLastIncomingMessage } from '../../utils/findLastIncomingMessage';

export const startPollingMessages = (): TThunkAction<void> => async (dispatch, getState, context) => {
  const pollingPeriod = context.config.get<number>('frontend-chats.chatbotPollingPeriod') || 5000;

  const pollingFunction = async () => {
    const {
      chatbot: { rowVersion },
      chatWindow: { currentOpenedChatId },
    } = getState();

    const response = await fetchChatbotMessages(context, rowVersion);

    /* istanbul ignore next */
    if (!response) {
      return;
    }

    if (currentOpenedChatId === CHATBOT_ID && response.unreadMessagesCount) {
      // тут осознанно нет await, так как клиент выставляет цифру
      fetchChatbotReadMessages(context);
    }

    dispatch(setMessagesFulfilled({ messages: response.messages, chatId: CHATBOT_ID }));

    const { openedChats } = getState();

    const chatbotChat = openedChats[CHATBOT_ID];

    const { pages } = chatbotChat;

    const pagesLastIndex = pages.length - 1;
    const { messages } = pages[pagesLastIndex];
    const messagesLastIndex = messages.length - 1;

    const lastMessage = findLastIncomingMessage(chatbotChat, pagesLastIndex, messagesLastIndex);

    dispatch(setChatbotRowVersion(lastMessage?.rowVersion || 0));
    dispatch(setChatbotUnreadMessagesCount(currentOpenedChatId === CHATBOT_ID ? 0 : response.unreadMessagesCount));
    dispatch(setChatbotPeriodicity(response.periodicity));
    dispatch(setChatbotHasPollAnswers(response.hasPollAnswers));
  };

  await pollingFunction();

  const intervalId = window.setInterval(pollingFunction, pollingPeriod);

  dispatch(setChatbotPollingIntervalId(intervalId));
};
